import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function NotFound() {
  const { t, lang } = useLang();
  return (
    <section className="section-padding">
      <div className="container-max text-center py-20">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-brand-yellow-dark">404</p>
        <h1 className="mt-3 font-heading text-5xl sm:text-6xl font-bold text-slate-900">
          {lang === "es" ? "Página no encontrada." : "Page not found."}
        </h1>
        <p className="mt-4 text-slate-600 text-lg">
          {lang === "es"
            ? "La página que busca no está aquí. Volvamos a empezar."
            : "The page you're looking for isn't here. Let's get you back on track."}
        </p>
        <div className="mt-7 flex justify-center gap-3">
          <Link to="/" className="inline-flex items-center justify-center bg-brand-navy hover:bg-brand-navy/90 text-white font-bold py-3 px-6 rounded-xl">
            {lang === "es" ? "Volver al inicio" : "Back to home"}
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-brand-navy text-brand-navy hover:bg-brand-navy hover:text-white font-bold py-3 px-6 rounded-xl transition-colors">
            {t.cta.viewAll}
          </Link>
        </div>
      </div>
    </section>
  );
}
